<template>
  <!-- (7-4)教育机构添加招募者页面 从6-3跳转而来 -->
  <div class="main-css">
    <div class="main-box">
      <!-- 搜索部分 -->
      <!--      顶部盒子-->
      <div class="up-box">
        <!--顶部条-->
        <div class="top2">
          <p>案件番号 {{ jobId }}</p>
        </div>
        <div class="top3">
          <p>採用担当 {{ userName }}</p>
        </div>
      </div>
      <div class="top1">
        <p>医療機関 {{ medicalName }}</p>
      </div>

      <div class="top-box">
        <div class="topFont1">
          <p>{{ $t("projectTitle") }}</p>
        </div>

        <div class="line"></div>

        <div class="topFont2">
          <p>{{ jobName }}</p>
        </div>
      </div>

      <!-- table部分 -->
      <div class="table">
        <el-table
          :data="tableData"
          style="width: 95%"
          height="410"
          @sort-change="changeTableSort"
          v-loading="loading"
          @selection-change="handleSelectionChange"
          @row-click="talentDetail"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <!-- ----------------------人材番号---------------------- -->
          <el-table-column
            prop="resumeId"
            label="人材番号"
            width="130"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("talentNumber") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                placeholder="Search"
                @input="handleEducationResumeInfoFuzzyQuery"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span
                @click="jump(scope.row.resumeId, scope.row.applicationStatus)"
                >{{ scope.row.resumeId }}</span
              >
            </template>
          </el-table-column>
          <!-- ----------------------氏名---------------------- -->
          <el-table-column
            prop="name"
            label="氏名"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("name") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @input="handleEducationResumeInfoFuzzyQuery"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <!-- ---------------------性别-------------------- -->
          <el-table-column prop="sex" label="性别">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("sex") }}</p>
              <el-dropdown @command="handleCommandSex">
                <span class="el-dropdown-link">
                  {{ opSex }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in sexValue"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                  <el-dropdown-item :command="null">
                    {{ "ALL" }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'JP'">{{
                scope.row.jpsex_dictText
              }}</span>
              <span v-else>{{ scope.row.sex_dictText }}</span>
            </template>
          </el-table-column>

          <!--          &lt;!&ndash; &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;就職担当&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; &ndash;&gt;-->
          <!--          <el-table-column prop="principal" width="140" label="就職担当"  :show-overflow-tooltip="true">-->
          <!--            <template slot="header">-->
          <!--              <p>{{ $t("inauguration") }}</p>-->
          <!--              <el-dropdown @command="handleCommandPrincipal">-->
          <!--                <span class="el-dropdown-link" >-->
          <!--                 All <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
          <!--                </span>-->
          <!--                <el-dropdown-menu slot="dropdown">-->
          <!--                  <el-dropdown-item-->
          <!--                    v-for="(item2,index) in principalData"-->
          <!--                    :key="item2.userId"-->
          <!--                    :command="item2"-->
          <!--                  >{{item2.userName}}</el-dropdown-item>-->

          <!--                </el-dropdown-menu>-->
          <!--              </el-dropdown>-->
          <!--            </template>-->
          <!--            <template slot-scope="scope">-->
          <!--              {{scope.row.principal}}-->
          <!--            </template>-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-dropdown @command="handleChangePrincipal">-->
          <!--                <span class="el-dropdown-link2" >-->
          <!--                 {{scope.row.principal}}-->
          <!--                </span>-->
          <!--                <el-dropdown-menu slot="dropdown">-->
          <!--                  <el-dropdown-item-->
          <!--                    v-for="(item2,index) in principalData"-->
          <!--                    :key="item2.userId"-->
          <!--                    :command="beforeHandleCommand(item2,scope.row.jobId)"-->
          <!--                  >{{item2.userName}}</el-dropdown-item>-->

          <!--                </el-dropdown-menu>-->
          <!--              </el-dropdown>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!-- -----------------------生年月日----------------------- -->
          <el-table-column
            prop="birth"
            label="生年月日"
            width="210"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("birth") }}</p>
              <el-date-picker
                v-model="searchData5"
                type="datetimerange"
                range-separator="~"
                :start-placeholder="$t('deliveryTimein')"
                :end-placeholder="$t('deliveryTimeout')"
                class="data-timer-picker"
                @blur="dataTimeChange"
                @change="pickerChangeFn"
                format="yyyy-MM-dd HH-mm-ss"
              >
              </el-date-picker>
            </template>
            <template slot-scope="scope">
              {{ scope.row.birth }}
            </template>
          </el-table-column>
          <!-- ------------------------学歴------------------------ -->
          <el-table-column
            prop="education"
            label="学歴"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationalBackgroundMatter") }}</p>
              <el-input
                v-model="searchData6"
                size="mini"
                placeholder="Search"
                @input="handleEducationResumeInfoFuzzyQuery"
                clearable
              />
            </template>
            <!--QAQ-->
            <template slot-scope="scope">
              <span v-if="language === 'JP'">{{
                scope.row.jpeducation_dictText
              }}</span>
              <span v-else>{{ scope.row.education_dictText }}</span>
            </template>
          </el-table-column>
          <!-- --------------------------専攻-------------------------- -->
          <el-table-column
            prop="profession"
            label="専攻"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("major") }}</p>
              <el-input
                v-model="searchData7"
                size="mini"
                placeholder="Search"
                @input="handleEducationResumeInfoFuzzyQuery"
                clearable
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.profession }}
            </template>
          </el-table-column>
          <!-- --------------------------日本語-------------------------- -->
          <el-table-column
            prop="japanese"
            label="日本語"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("japaneseVs") }}</p>
              <el-input
                v-model="searchData8"
                size="mini"
                placeholder="Search"
                @input="handleEducationResumeInfoFuzzyQuery"
                clearable
              />
            </template>
            <!--QAQ-->
            <template slot-scope="scope">
              <span v-if="language === 'JP'">{{
                scope.row.jpjapanese_dictText
              }}</span>
              <span v-else>{{ scope.row.japanese_dictText }}</span>
            </template>
          </el-table-column>
          <!-- --------------------------観覧回数-------------------------- -->
          <el-table-column
            prop="visitedTime"
            label="観覧回数"
            width="150"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("numberOfVisits") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.visitedTime }}
            </template>
          </el-table-column>
        </el-table>

        <!--      <el-dialog title="" :visible.sync="dialogIsShow1" width="30%">-->
        <!-- 弹窗成功提示 -->
        <div class="employee-application" v-if="dialogIsShow1">
          <div class="dialog-box">
            <!-- 弹窗的操作部分 -->
            <div class="im-box">
              <div class="div-1">
                <div class="row">
                  <img src="./assets/Vector.svg" alt="" />
                </div>
              </div>

              <!--          内容-->
              <div class=" div-2">
                <div class="div-2-main">
                  <p>{{ $t("successfulApplication") }}</p>
                </div>
              </div>

              <!--          按钮-->
              <div class=" div-3">
                <button class="button" @click="dialogClose1">
                  {{ $t("close") }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- 弹窗失败提示 -->
        <div class="employee-application" v-if="dialogIsShow2">
          <div class="im-box">
            <div class="div-1">
              <div class="row">
                ×
              </div>
            </div>

            <!--          内容-->
            <div class=" div-2">
              <div class="div-2-main">
                <p>{{ $t("failulApplication") }}</p>
              </div>
            </div>

            <!--          按钮-->
            <div class=" div-3">
              <button class="button" @click="dialogClose2">
                {{ $t("close") }}
              </button>
            </div>
          </div>
        </div>
        <!--      </el-dialog>-->
      </div>

      <!-- --------------------------弹窗dialog-------------------------- -->
      <el-dialog
        title="个人简历浏览"
        :visible.sync="addDialogVisible"
        width="600px"
      >
        <div class="left-box">
          <!-- 主要信息部分 -->
          <div class="main-left-box">
            <!-- 显示图片 -->
            <div class="case-img">
              <!--图片未传-->
              <div class="one-box-left1">
                <img
                  :src="img"
                  alt=""
                  @error="
                    e => {
                      e.target.src = require('@/assets/defaultImg.png');
                    }
                  "
                />
              </div>
              <div class="one-box-left2">
                <div class="one-box-left-line1">
                  <div class="one-box-left-line-smallleft">
                    <p></p>
                  </div>
                  <div class="one-box-left-line-smallright">
                    <el-tooltip :content="tableDataDetail.anonym">
                      <p>{{ tableDataDetail.anonym }}</p></el-tooltip
                    >
                  </div>
                </div>
                <div class="one-box-left-line2">
                  <div class="one-box-left-line-smallleft">
                    <p>{{ $t("name") }}</p>
                  </div>
                  <div class="one-box-left-line-smallright">
                    <p>{{ tableDataDetail.name }}</p>
                  </div>
                </div>
                <div class="one-box-left-line3">
                  <div class="one-box-left-line-smallleft">
                    <p>{{ $t("sex") }}</p>
                  </div>
                  <div class="one-box-left-line-smallright">
                    <span v-if="language == 'JP'">{{
                      this.tableDataDetail.jpsex_dictText
                    }}</span>
                    <span v-else>{{ this.tableDataDetail.sex_dictText }}</span>
                  </div>
                </div>
                <div class="one-box-left-line4">
                  <div class="one-box-left-line-smallleft">
                    <p>{{ $t("birth") }}</p>
                  </div>
                  <div class="one-box-left-line-smallright">
                    <p>
                      {{
                        tableDataDetail.birth &&
                          tableDataDetail.birth.split(" ")[0]
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <!-- 标签部分 -->
            <div class="label">
              <!--qaq-->
              <div
                class="label-box-active"
                v-if="this.tableDataDetail.label1 == 1"
              >
                <div v-if="language == 'JP'">
                  {{ this.tableDataDetail.jplabel1_dictText }}
                </div>
                <div v-else>{{ this.tableDataDetail.label1_dictText }}</div>
              </div>
              <div
                class="label-box-active"
                v-if="this.tableDataDetail.label2 == 1"
              >
                <div v-if="language == 'JP'">
                  {{ this.tableDataDetail.jplabel2_dictText }}
                </div>
                <div v-else>{{ this.tableDataDetail.label2_dictText }}</div>
              </div>
              <div
                class="label-box-active"
                v-if="this.tableDataDetail.label3 == 1"
              >
                <div v-if="language == 'JP'">
                  {{ this.tableDataDetail.jplabel3_dictText }}
                </div>
                <div v-else>{{ this.tableDataDetail.label3_dictText }}</div>
              </div>
              <div
                class="label-box-active"
                v-if="this.tableDataDetail.label1 == 1"
              >
                <div v-if="language == 'JP'">
                  {{ this.tableDataDetail.jplabel1_dictText }}
                </div>
                <div v-else>{{ this.tableDataDetail.label1_dictText }}</div>
              </div>
            </div>
            <!-- 第一行 -->
            <div class="inline-box">
              <div class="inline-left">
                <div class="inline-left-title">{{ $t("contactAddress") }}</div>
                <div class="inline-left-title-main">
                  {{ $t("currentAddress") }}
                  <el-tooltip :content="tableDataDetail.address">
                    <div class="inline-left-title-main-right">
                      {{ tableDataDetail.address }}
                    </div></el-tooltip
                  >
                </div>

                <div class="inline-left-title-main">
                  {{ $t("email") }}
                  <el-tooltip :content="tableDataDetail.email">
                    <div class="inline-left-title-main-right">
                      {{ tableDataDetail.email }}
                    </div></el-tooltip
                  >
                </div>

                <div class="inline-left-title-main">
                  {{ $t("telephoneNumber") }}
                  <el-tooltip :content="tableDataDetail.telephone">
                    <div class="inline-left-title-main-right">
                      {{ tableDataDetail.telephone }}
                    </div></el-tooltip
                  >
                </div>
              </div>
              <div class="inline-right">
                <div class="inline-left-title">{{ $t("education") }}</div>

                <div class="inline-left-title-main">
                  {{ $t("period") }}
                  <el-tooltip
                    :content="
                      `${tableDataDetail.enrollment}~${tableDataDetail.graduation}`
                    "
                  >
                    <div class="inline-left-title-main-right-long">
                      {{ tableDataDetail.enrollment }}~{{
                        tableDataDetail.graduation
                      }}
                    </div></el-tooltip
                  >
                </div>

                <div class="inline-left-title-main">
                  {{ $t("school") }}
                  <el-tooltip :content="tableDataDetail.school">
                    <div class="inline-left-title-main-right">
                      {{ tableDataDetail.school }}
                    </div></el-tooltip
                  >
                </div>

                <div class="inline-left-title-main">
                  {{ $t("major") }}
                  <el-tooltip :content="tableDataDetail.profession">
                    <div class="inline-left-title-main-right">
                      {{ tableDataDetail.profession }}
                    </div></el-tooltip
                  >
                </div>
              </div>
            </div>
            <!-- 第二行 -->
            <div class="inline-box">
              <div class="inline-left">
                <div class="inline-left-title">{{ $t("qualification") }}</div>
                <div class="inline-left-title-main">
                  {{ tableDataDetail.qualification1 }}
                </div>

                <div class="inline-left-title-main">
                  {{ tableDataDetail.qualification2 }}
                </div>

                <div class="inline-left-title-main">
                  {{ tableDataDetail.qualification3 }}
                </div>
              </div>
              <div class="inline-right">
                <div class="inline-left-title">{{ $t("workHistory") }}</div>
                <div class="inline-left-title-main">
                  {{ $t("period") }}
                  <el-tooltip
                    :content="
                      `${tableDataDetail.startYear}~${tableDataDetail.endYear}`
                    "
                  >
                    <div class="inline-left-title-main-right-long">
                      {{ tableDataDetail.startYear }} &#12288;
                      {{ tableDataDetail.endYear }}
                    </div></el-tooltip
                  >
                </div>

                <div class="inline-left-title-main">
                  {{ $t("companyName") }}
                  <el-tooltip :content="tableDataDetail.institutionName">
                    <div class="inline-left-title-main-right">
                      {{ tableDataDetail.institutionName }}
                    </div></el-tooltip
                  >
                </div>

                <div class="inline-left-title-main">
                  {{ $t("affiliation") }}
                  <el-tooltip :content="tableDataDetail.type">
                    <div class="inline-left-title-main-right">
                      {{ tableDataDetail.type }}
                    </div></el-tooltip
                  >
                </div>
              </div>
            </div>
            <!-- 第三行 -->
            <div class="inline-box">
              <div class="inline-left">
                <div class="inline-left-title">{{ $t("languageSkills") }}</div>
                <div class="inline-left-title-main">
                  {{ $t("japanese") }}
                  <div class="inline-left-title-main-right">
                    <span v-if="language == 'JP'">{{
                      this.tableDataDetail.jpjapanese_dictText
                    }}</span>
                    <span v-else>{{
                      this.tableDataDetail.japanese_dictText
                    }}</span>
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("english") }}
                  <div class="inline-left-title-main-right">
                    <span v-if="language == 'JP'">{{
                      this.tableDataDetail.jpenglish_dictText
                    }}</span>
                    <span v-else>{{
                      this.tableDataDetail.english_dictText
                    }}</span>
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("other") }}
                  <div class="inline-left-title-main-right">
                    {{ tableDataDetail.other }}
                  </div>
                </div>
              </div>
              <div class="inline-right">
                <div class="inline-left-title">{{ $t("request") }}</div>

                <div class="inline-left-title-main-long" style="width: 220px">
                  {{ $t("joinCompany") }}
                  <el-tooltip
                    :content="
                      `${tableDataDetail.startYear}~${tableDataDetail.endYear}`
                    "
                  >
                    <div class="inline-left-title-main-right-long">
                      {{ tableDataDetail.startYear }} &#12288;
                      {{ tableDataDetail.endYear }}
                    </div></el-tooltip
                  >
                </div>

                <div class="inline-left-title-main">
                  {{ $t("workLocation") }}
                  <div class="inline-left-title-main-right">
                    {{ tableDataDetail.workPlace }}
                  </div>
                </div>

                <div class="inline-left-title-main">
                  {{ $t("occupation") }}
                  <div class="inline-left-title-main-right">
                    {{ tableDataDetail.profession }}
                  </div>
                </div>
              </div>
            </div>

            <!-- 第五行 -->
            <div class="inline-log-box">
              <div class="long-box-title">{{ $t("selfPR") }}</div>
              <el-tooltip :content="tableDataDetail.pr">
                <div class="long-box-main">
                  {{ tableDataDetail.pr }}
                </div></el-tooltip
              >
            </div>
          </div>
        </div>
      </el-dialog>

      <!-- 分页部分 -->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pageNumber"
            layout=" prev, pager, next"
            :total="total"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>

      <!-- button部分 -->
      <div class="main-button">
        <button @click="applyClick">{{ $t("apply") }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  applicationInfoBinding,
  fuzzyApplyResumeInfo,
  getUrlFromOSS,
  queryApplyResumeInfo
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";

export default {
  name: "educationalInstitutionAddRecruiter",
  components: {},
  data() {
    return {
      jobId: "",
      jobName: "",
      userName: "",
      medicalName: "",
      resumeId: "",
      name: "",
      sex: "",
      birth: "",
      education: "",
      profession: "",
      japanese: "",
      visitedTime: "",
      inputData1: "", //搜索框input内容
      tableData: [], //   table内容
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索n
      searchData4: "", //表格第四个搜索
      searchData5: "",
      searchData6: "",
      searchData7: "",
      searchData8: "", //表格第八个搜索
      addDialogVisible: false,
      dialogIsShow1: false, //dialog弹窗标识
      dialogIsShow2: false, //dialog失败弹窗标识
      birthStart: "",
      birthEnd: "",
      dropdownData1: "", //第一个下拉
      pageNumber: 1, //页数
      pageSize: 7, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      multipleSelection: [],
      tableDataDetail: [],
      language: "",
      sexValue: [],
      opSex: "All",
      img: ""
    };
  },
  created() {
    this.language = this.$i18n.locale;
    this.sexs();
    console.log("接收过来的值为：" + this.$route.params.jobId);
    this.jobId = this.$route.params.jobId;
    this.jobName = this.$route.params.jobName;
    this.userName = this.$route.params.userName;
    this.medicalName = this.$route.params.medicalName;

    this.searchDataStart = this.$route.query.searchData;
    console.log(this.searchDataStart);
    this.showTable();
  },
  //qaq
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {},
  methods: {
    //图片回显
    getUrl(url) {
      console.log("url" + url);
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("图片回显接口1");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.img = aesFecInfo.message;
          } else {
            console.log(res);
          }
        })
        .catch(() => {});
    },
    languageChange(e) {
      const that = this;
      console.log("------监听数据10------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = that.$i18n.locale;
        that.sexs();
        console.log("接收过来的值为：" + that.$route.params.jobId);
        that.jobId = that.$route.params.jobId;
        that.jobName = that.$route.params.jobName;
        that.userName = that.$route.params.userName;
        that.medicalName = that.$route.params.medicalName;
        that.searchDataStart = that.$route.query.searchData;
        console.log(that.searchDataStart);
        that.showTable();
      }
    },
    //性别筛选
    handleCommandSex(e) {
      console.log(e);
      if (e == null) {
        this.sex = "";
        this.opSex = "All";
        console.log(e);
      } else {
        this.sex = e.code;
        this.opSex = e.name;
      }
      console.log(this.sex);
      this.handleEducationResumeInfoFuzzyQuery();
    },
    sexs() {
      var that = this;
      var dataItems = "";
      if (that.language === "JP") {
        dataItems = "jpsex";
      } else {
        dataItems = "sex";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.sexValue = aesFecInfo.data;
            console.log(that.sexValue);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    dialogClose1() {
      this.dialogIsShow1 = false;
    },
    dialogClose2() {
      this.dialogIsShow2 = false;
    },
    // 弹窗成功提示
    handleAddClick() {
      this.dialogIsShow1 = true;
      console.log(this.list);
    },
    showTable() {
      console.log("接收过来的值为：" + this.jobId);
      console.log(this.medicalName);
      var fakeInfo = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize
      };
      queryApplyResumeInfo(fakeInfo)
        .then(res => {
          console.log("应聘人才信息查询接口");
          console.log(res);
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          console.log(aesFecInfo);
          this.tableData = aesFecInfo.data;
          this.total = aesFecInfo.total;
        })
        .catch(() => {});
    },
    //选中
    handleSelectionChange(val) {
      this.multipleSelection = [];
      for (var i = 0; i < val.length; i++) {
        this.multipleSelection.push(val[i].resumeId);
      }
      console.log(this.multipleSelection);
    },
    applyClick() {
      var fakeInfo = {
        jobId: this.jobId,
        resumeIds: this.multipleSelection
      };
      applicationInfoBinding(fakeInfo)
        .then(res => {
          console.log("看看上个页面来的值");
          console.log(fakeInfo);
          console.log("应聘信息绑定接口");
          console.log(res);
          if (res.data.code === "A0000") {
            this.$message({
              message: this.$t("successfulApplication"),
              type: "success"
            });
          } else {
            this.$message({
              message: this.$t("failulApplication"),
              type: "error"
            });
          }
        })
        .catch(() => {});
    },
    //清空时间
    pickerChangeFn(value) {
      if (value === null) {
        this.birthStart = "";
        this.birthEnd = "";
      }
    },
    //data -time 选择
    dataTimeChange() {
      console.log(this.searchData5);
      this.birthStart = this.timeJs(this.searchData5[0]);
      this.birthEnd = this.timeJs(this.searchData5[1]);
      //模糊查询
      this.handleEducationResumeInfoFuzzyQuery();
    },
    //应聘人才信息模糊查询
    handleEducationResumeInfoFuzzyQuery() {
      var resumeFuzzyQueryDTO = {
        // birthEnd: this.birthEnd,
        // birthStart: this.birthStart,
        // education: this.searchData6,
        // japanese: this.searchData8,
        // name: this.searchData2,
        // pageNumber: this.currentPage,
        // pageSize: this.pageSize,
        // principal:this.principal ,
        // profession: this.searchData7,
        // resumeId: this.searchData1,
        // sex: this.sex
        avatar: "",
        birthEnd: this.birthEnd,
        birthStart: this.birthStart,
        education: this.searchData6,
        educationId: "",
        japanese: this.searchData8,
        jobId: "",
        name: this.searchData2,
        pageNumber: 1,
        pageSize: 15,
        profession: "",
        resumeId: this.searchData1,
        sex: this.sex,
        userId: "",
        visitedTime: 0
      };
      fuzzyApplyResumeInfo(resumeFuzzyQueryDTO)
        .then(res => {
          console.log("--------应聘人才信息模糊查询接口数据--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.tableData = aesFecInfo.data;
            console.log(this.tableData);
          }
        })
        .catch(res => {
          console.log("应聘人才信息模糊查询接口异常:", res);
        });
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "visitedTime") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["visitedTime"] - b["visitedTime"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["visitedTime"] - a["visitedTime"]
          );
        }
      }
    },
    handleCommand01(command) {
      if (command === "a") {
        console.log("选择了男");
      } else if (command === "b") {
        console.log("选择了女");
      }
    },
    //
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.showTable();
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
      } else if (command === "b") {
        this.pageSize = 15;
      } else if (command === "c") {
        this.pageSize = 20;
      } else if (command === "d") {
        this.pageSize = 25;
      }
      this.pageNumber = 1;
      this.showTable();
    },
    // 员工申请
    staffApplicationHandleAdd(row) {
      this.$router.push({
        path: "/advancedCertification",
        query: { rowData: row, role: 0 }
      });
    },
    //管理员申请
    managerApplicationHandleAdd(row) {
      this.$router.push({
        path: "/advancedCertification",
        query: { rowData: row, role: 1 }
      });
    },

    //人才详情
    talentDetail(row, column, cell, event) {
      console.log("开始展示人才简历");
      console.log(event);
      console.log(column);
      console.log(column.label);
      console.log(row);
      console.log("结束展示人才简历");
      this.resumeId = row.resumeId;

      var that = this;
      axios
        .get(
          "/api/modules-parent/educationalInstitutionTalentInfo/resumeDetailQuery",
          {
            params: {
              resumeId: this.resumeId
            },
            headers: {
              "content-type": "application/x-www-form-urlencoded",
              token: localStorage.getItem("token")
            }
          }
        )
        .then(res => {
          console.log(res);
          if (res.data.code == "A0000") {
            const aesFecInfoDeatail = JSON.parse(AES.decrypt(res.data.data));
            that.tableDataDetail = aesFecInfoDeatail.data[0];
            that.getUrl(that.tableDataDetail.avatar);
            console.log("这是我存的数组");
            console.log(that.tableDataDetail);
            this.addDialogVisible = true;
          } else {
            this.$message.error("查询失败。");
          }
        })
        .catch(res => {});
    },

    // 详情dialog close
    addDialogClose() {
      this.addDialogVisible = false;
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
}

.main-box {
  margin-top: 10px;
  width: 100%;
  height: 80%;
  padding: 0 40px 70px 80px;
  box-sizing: border-box;
}

.search {
  width: 100%;
  height: 25px;
  display: flex;
}

.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}

.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}

.search /deep/ .el-input__icon {
  line-height: 24px;
}

.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}

.table {
  margin-top: 20px;
  height: 420px;
  width: 100%;
}

.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
}

.operate {
  height: 48px;
}

.table /deep/ .el-dropdown {
  width: 50px;
}

.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}

.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.table /deep/ .el-table__cell {
  position: relative;
}

.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -3px;
  right: 0;
  width: 40px;
}

.pagination {
  width: 100%;
  height: 50px;
  margin-top: 10px;
}

.pagination-main {
  float: right;
  margin-right: 100px;
  display: flex;
}

.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}

.rowsPage-css {
  background: peru;
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}

.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}

.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}

.dialog-box {
  height: 630px;
  width: 400px;
  padding: 0 40px;
  padding: 20px 0;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
}

.top1 {
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: center;
  padding: 3px 17px;
  margin-top: 20px;
  width: 243px;
  height: 24px;
  /* 主色 */
  /* Body */
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
  /* 灰色字体 */
  color: #686868;
  background: #ffffff;
  /* 左边按钮颜色 */
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
}

/**/
.top2 {
  padding: 0 10px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-top: 20px;
  float: right;
  margin-right: 10px;
}

.top3 {
  /* Auto layout */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 3px 17px;
  /* width: 138px; */
  height: 24px;
  /* 主色 */
  background: #ffffff;
  /* 左边按钮颜色 */
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  /* Body */
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
  /* 灰色字体 */
  margin-top: 20px;
  color: #686868;
}

.form-button {
  text-align: center;
}

.form-button button {
  /* 第二主色 */
  background: #fc630c;
  border-radius: 4px;
  padding: 10px 16px;
  gap: 10px;
  color: #ffffff;
  font-weight: 500;
  font-size: 14px;
}

.topFont1 {
  width: 100%;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 34px;
  color: #686868;
}

.topFont2 {
  width: 100%;
  /* 左侧按钮式样 */
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 34px;
  /* identical to box height, or 189% */
  display: flex;
  align-items: center;
  /* 灰色字体 */
  color: #686868;
}

.line {
  left: 31.46%;
  right: 37.94%;
  top: 22%;
  bottom: 78%;
  width: 35%;
  /* 灰色字体 */
  border: 1px solid #686868;
}

/**/
.top-box {
  width: 100%;
  height: 100px;
  margin-top: 50px;
  margin-left: 10px;
}

/**/
.up-box {
  float: right;
  margin-right: 1%;
  display: flex;
}

.main-css {
  width: 100%;
  height: 100%;
  position: relative;
}

.main-box {
  margin-top: 0px;
  width: 100%;
  padding: 0 40px 70px 80px;
  box-sizing: border-box;
}

.table /deep/ .el-date-editor {
  width: 210px;
}

.left-box {
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.top-title {
  height: 40px;
  width: 530px;
  display: flex;
  justify-content: center;
  align-content: center;
}

.case-num {
  padding: 0 10px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-top: 10px;
  float: right;
  margin-left: 5px;
}

.main-left-box {
  width: 568px;
  padding-right: 18px;

  /*overflow-y: scroll;*/
  overflow-y: hidden;
}

.case-img {
  margin-top: 40px;
  width: 100%;
  height: 114px;
  display: flex;
  justify-content: space-between;
}

.label {
  width: 100%;
  height: 26px;
  margin-top: 20px;
}

.inline-left {
  width: 200px;
  height: 130px;
  margin-right: 45px;
  float: left;
  /*background: #51abff;*/
}

.inline-left-title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
  /*background:yellow;*/
}

.inline-left-title-main {
  width: 340px;
  height: 32px;
  line-height: 50px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  /*background: peru;*/
}

.inline-left-title-main-long {
  width: 150px;
  height: 32px;
  line-height: 50px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /*background: peru;*/
}

.inline-left-title-main-right {
  width: 82%;
  height: 32px;
  line-height: 50px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  float: right;
}

.inline-left-title-main-right-long {
  width: 152px;
  height: 32px;
  line-height: 50px;
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0.25px;
  color: #686868;
  float: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.inline-box {
  height: 60px;
  width: 100%;
  margin-top: 10px;
}

.inline-log-box {
  margin-top: 10px;
  width: 100%;
  height: 120px;
}

.long-box-title {
  /*height: 360px;*/
  line-height: 30px;
  width: 485px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.long-box-main {
  width: 485px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

.label-box {
  padding: 0 5px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  float: left;
  margin-right: 20px;
}

.case-img img {
  width: 150px;
  height: 114px;
}

.one-box-left1 {
  width: 200px;
  height: 70%;
  padding-left: 20px;
  padding-top: 5px;
  box-sizing: border-box;
  display: flex;
  justify-content: left;
}

.one-box-left2 {
  width: 600px;
  height: 100px;
  background: #ffffff;
  border-radius: 4px;
  margin: auto;
}

.one-box-left-line1 {
  width: 80%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line2 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line3 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line4 {
  width: 90%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line-smallleft {
  width: 20%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  /* or 171% */
  display: flex;
  align-items: center;
  /* 灰色字体 */
  color: #686868;
}

.one-box-left-line-smallright {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* or 143% */

  display: flex;
  align-items: center;

  /* 灰色字体 */

  color: #686868;
}

.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}

.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}

.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}

.title-css {
  /*标题样式*/
  font-family: "lucida sans unicode", "lucida grande", sans-serif;
  /*字体*/
  color: #686868;
  /*字体颜色*/
  font-size: 2em;
  /*字体大小*/
  text-align: center;
  /*对齐方式*/
  line-height: 76px;
  /*行间距*/
  margin-top: 10px;
}

.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin-top: 25px;
  margin-left: 40px;
}

.button-css {
  width: 200px;
  height: 35px;
  background: #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  margin-right: 25px;
}

.search {
  width: 100%;
  height: 25px;
  display: flex;
}

.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}

.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}

.search /deep/ .el-input__icon {
  line-height: 24px;
}

.save-button {
  height: 36px;
  background: #fff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  color: #51abff;
  cursor: pointer;
  margin-right: 10px;
}

.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}

.table {
  width: 100%;
  margin-top: 20px;
  height: 430px;
}

.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}

.operate {
  height: 51px;
}

.table /deep/ .el-dropdown {
  width: 60px;
}

.table-img-css {
  border-radius: 50%;
}

.el-dropdown-link2 {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  margin-left: -26px;
  width: 100%;
  display: inline-block;
}

.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.table /deep/ .el-table__cell {
  position: relative;
  text-align: center;
}

.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -5px;
  right: -20px;
  width: 67px;
}

.pagination {
  width: 95%;
  height: 50px;
  margin-top: 10px;
}

.pagination-main {
  float: right;
  margin-right: 10px;
  display: flex;
}

.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}

.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}

.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}

.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}

.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.case-num {
  padding: 0 10px;
  height: 24px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  line-height: 22px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #686868;
  margin-top: 10px;
  float: right;
  margin-left: 5px;
}

.left-box {
  width: 550px;
  height: 650px;
  /*float: left;*/
  overflow: hidden;
  padding-bottom: 20px;
  position: relative;
}

.main-left-box {
  width: 568px;
  padding-right: 18px;
  height: 650px;
  overflow-y: scroll;
  position: absolute;
  left: 0;
  top: 0;
  right: -17px;
  bottom: 0;
  overflow-x: hidden;
}

.case-name {
  height: 55px;
  width: 100%;
}

.case-name .title {
  width: 440px;
  height: 25px;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.case-name .title-name {
  height: 30px;
  width: 440px;
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  color: #686868;
}

.case-img {
  margin-top: 40px;
  width: 100%;
  height: 114px;
  display: flex;
  justify-content: space-between;
}

.case-img img {
  width: 150px;
  height: 114px;
}

.label {
  width: 100%;
  height: 26px;
  margin-top: 20px;
}

.label-box {
  padding: 0 5px;
  background: #b2b2b2;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #ffffff;
  float: left;
  margin-right: 20px;
}

.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}

.left-button {
  width: 100%;
  height: 41px;
}

.inline-left {
  width: 200px;
  height: 130px;
  margin-right: 45px;
  float: left;
  /*background: #51abff;*/
}

.inline-right {
  width: 240px;
  height: 180px;
  margin-right: 45px;
  float: left;
}

.inline-left-title {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
  /*background:yellow;*/
}

.inline-left-title-main {
  width: 220px;
  height: 32px;
  line-height: 50px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  /*background: peru;*/
}

.inline-left-title-main-right {
  width: 162px;
  height: 32px;
  line-height: 50px;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #686868;
  float: right;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.inline-box {
  height: 60px;
  width: 100%;
  margin-top: 10px;
}

.inline-log-box {
  margin-top: 10px;
  width: 100%;
  height: 120px;
}

.long-box-title {
  height: 360px;
  line-height: 30px;
  width: 485px;
  font-weight: 700;
  font-size: 14px;
  color: #686868;
  border-bottom: 1px solid #686868;
}

.long-box-main {
  width: 485px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #686868;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

.one-box-left1 {
  width: 200px;
  height: 70%;
  padding-left: 20px;
  padding-top: 5px;
  box-sizing: border-box;
  display: flex;
  justify-content: left;
}

.one-box-left2 {
  width: 600px;
  height: 100px;
  background: #ffffff;
  border-radius: 4px;
  margin: auto;
}

.one-box-left-line1 {
  width: 80%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line2 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line3 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line4 {
  width: 80%;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.one-box-left-line-smallleft {
  width: 40%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 800;
  font-size: 15px;
  line-height: 24px;
  /* or 171% */
  display: flex;
  align-items: center;
  /* 灰色字体 */
  color: #686868;
}

.one-box-left-line-smallright {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  /* or 143% */

  display: flex;
  align-items: center;

  /* 灰色字体 */

  color: #686868;
}

.label-box-active {
  float: left;
  height: 24px;
  padding: 0 5px;
  line-height: 24px;
  background: #51abff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  cursor: pointer;
  overflow: hidden;
  margin-right: 20px;
}

.label-box-active span {
  height: 13px;
  width: 13px;
  background: #fff;
  border-radius: 50%;
  line-height: 13px;
  text-align: center;
  margin-left: 10px;
  display: inline-block;
  color: #b2b2b2;
}

.label-box span {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #fff;
  line-height: 14px;
  color: #b2b2b2;
  text-align: center;
  margin-left: 10px;
  cursor: pointer;
}

.info-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.schedule-box span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.chat-box-css {
  width: 530px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 10px;
  position: relative;
}

.chat-box-css span {
  position: absolute;
  top: -12px;
  left: 15px;
  display: inline-block;
  height: 24px;
  padding: 0 5px;
  background: #ffffff;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  z-index: 10;
}

.chat-box-css /deep/ .search .el-input__inner {
  background: transparent;
}

.chat-box-css /deep/ .send-message {
  height: 60px;
}

.chat-box-css /deep/ .send-message .el-input__inner {
  border-radius: 0;
  border-bottom: 1px solid #51abff;
}

.main-left-box {
  width: 568px;
  padding-right: 18px;
  /* height: 650px; */
  overflow-y: scroll;
}

.main-button {
  width: 500px;
  height: 50px;
  text-align: center;
  margin-left: 455px;
  margin-left: 30%;
}

.main-button button {
  cursor: pointer;
  height: 40px;
  width: 152px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
}

.im-box {
  width: 498px;
  height: 266px;
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  margin: auto;
  position: absolute;
  left: 600px;
  top: 0px;
}

.div-1 {
  width: 100%;
  height: 90px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 80px;
}

.row {
  width: 50px;
  height: 50px;
  text-align: center;
  /* 第二主色 */
  background: #fc630c;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: courier, "courier new", monospace; /*字体*/
  color: #ffffff; /*字体颜色*/
  font-size: 55px; /*字体大小*/
  margin-top: 40px;
}

.div-2 {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.div-2-main {
  width: 280px;
  height: 48px;
  /* 表头样式 */
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  /* 灰色字体 */
  color: #686868;
  text-align: center;
}

.div-3 {
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button {
  position: static;
  background: #fff;
  height: 24px;
  left: 17px;
  top: 0px;
  color: #fc630c;
  padding: 0px 19px;
  border: 1px solid #fc630c;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 10px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/educationalInstitutionAddRecruiter/index.vue